import React, { useEffect, useState } from "react";
import { Facebook, Youtube } from "iconsax-reactjs";
import PrimeLogo from "../../assets/logo2.svg";

const Footer = () => {
  const menuItems = [
    {
      title: "Home",
      link: "#Home",
    },
    {
      title: "About Us",
      link: "#About-Us",
    },
    {
      title: "Products and Services",
      link: "#Products-and-Services",
    },
    {
      title: "Team",
      link: "#Team",
    },
    { title: "Testimonials", link: "#Testimonials" },
    {
      title: "FAQ",
      link: "#FAQ",
    },
  ];

  return (
    <footer className="bg-[#24215A] text-white w-full">
      <div className="container mx-auto px-6 sm:px-10 lg:px-32 py-12">
        {/* Top Section */}
        <div className="grid gap-10 md:grid-cols-3">
          {/* Logo */}
          <div className="flex justify-center md:justify-start">
            <img
              src={PrimeLogo}
              alt="Prime Steel Trading Logo"
              className="h-16"
            />
          </div>

          {/* Links */}
          <div className="text-center md:text-left">
            <ul className="space-y-3 font-light text-gray-300">
              {menuItems.map((item, i) => (
                <li key={i}>
                  <a href={item.link} className="hover:text-white">
                    {item.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact & Socials */}
          <div className="text-center md:text-left">
            <div className="text-lg font-bold space-y-1">
              <p className="text-2xl">+2519-64-33-33-33</p>
              <p className="text-2xl">+2519-11-25-23-97</p>
            </div>
            <p className="mt-3 max-w-sm text-gray-300 mx-auto md:mx-0">
              Teklehaymanot around berbere berenda waliya building 50m above.
            </p>
            <div className="mt-6 flex justify-center md:justify-start flex-wrap gap-4">
              {[
                {
                  label: "LinkedIn",
                  icon: <Facebook size="24" color="#CBD5E0" />,
                },
                {
                  label: "Facebook",
                  icon: <Facebook size="24" color="#CBD5E0" />,
                },
                {
                  label: "Twitter",
                  icon: <Facebook size="24" color="#CBD5E0" />,
                },
                {
                  label: "YouTube",
                  icon: <Youtube size="24" color="#CBD5E0" />,
                },
              ].map((social, i) => (
                <a
                  key={i}
                  href="#"
                  aria-label={social.label}
                  className="rounded-full border border-gray-500 p-2 text-gray-300 transition-colors hover:text-white"
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Divider */}
        <hr className="my-8 border-gray-700" />

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row items-center justify-between text-gray-400 text-sm space-y-4 md:space-y-0">
          <div className="flex flex-wrap justify-center md:justify-start gap-4">
            <a href="#" className="hover:text-white">
              Contact us
            </a>
            <a href="#" className="hover:text-white">
              Terms of use
            </a>
            <a href="#" className="hover:text-white">
              Privacy Cookie
            </a>
            <a href="#" className="hover:text-white">
              Policy
            </a>
          </div>
          <p>© 2025 PRIME Steel Trading</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
